import { MiniAppCoreError } from '../config/error'
import * as yup from 'yup'

/**
 * for validate payload by compare with the schema
 *
 * @example
 * ```javascript
 *  public static async showOverlay(payload: ShowOverlayPayload): Promise<void> {
 *    const schema: yup.SchemaOf<ShowOverlayPayload> = yup.object({
 *      id: yup.string().required(),
 *      loop: yup.number().required(),
 *      alignment: yup.string().required(),
 *    })
 *  await Validator.validate(schema, payload)
 *    return this.bridge.showOverlay()
 *  }
 *```
 *
 */
export default class PayloadValidator {
  public static async validate(schema: yup.AnySchema, payload: any) {
    try {
      await schema.validate(payload, { abortEarly: true })
      return true
    } catch (error: any) {
      throw new MiniAppCoreError('VALIDATION_ERROR', {
        cause: error.message,
      })
    }
  }
}
